import CITIES_COUNTRIES from '../../../assets/cities-countries';
import BelfioreConnector from './classes/belfiore-connector.class';
import IBelfioreCity from './interfaces/belfiore-city.interface';
import IBelfioreCountry from './interfaces/belfiore-country.interface';
import IBelfiorePlace from './interfaces/belfiore-place.interface';
import BelfioreConnectorConfig from './types/belfiore-connector-config.type';

export type BelfiorePlace = IBelfiorePlace | IBelfioreCity | IBelfioreCountry;

export const Belfiore = new BelfioreConnector(
  CITIES_COUNTRIES as BelfioreConnectorConfig
);
export { BelfioreConnector };
